


































































































































import { Component, Vue } from "vue-property-decorator"
import {
  STATUSES as BOOKING_STATUSES,
  TYPES_DISPLAY,
  TYPES,
  BOOKING_PURPOSES
} from "@/constants/booking"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import BookingListFilterForm from "./List/BookingListFilterForm.vue"
import BookingListFilterChip from "./List/BookingListFilterChip.vue"
import QShareCode from "@/components/QShareCode.vue"

@Component({
  components: {
    BookingListFilterForm,
    BookingListFilterChip,
    QShareCode,
  },
  filters: {
    candidateName: (item, index) => {
      const arr = [item.first_name ?? null, item.last_name ?? null]

      const candidateName = arr.filter(Boolean).join(" ")

      if (candidateName.length == 0) {
        return `Candidate ${index + 1}`
      }

      return candidateName
    },
    candidateContact: (item) => {
      const arr = [item.email ?? null, item.mobile ?? null]

      return arr.filter(Boolean).join(", ")
    },
  },
})
export default class BookingList extends Vue {
  // Data
  options: BookingListFilterOptions = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: "updated_at",
    orderByDirection: "desc",
    statuses: [],
    type: null,
    paymentMethod: null,
    candidateName: null,
    businessOid: "",
  }
  statuses = BOOKING_STATUSES
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES
  typesDisplay = TYPES_DISPLAY
  types = TYPES
  purposes = BOOKING_PURPOSES
  search = ""

  showCandidateListDrawer = false
  selectedBooking: Booking | null = null

  headers = [
    { text: "Booking ID", value: "gid" },
    {
      text: "Risk Profile",
      value: "risk_profile.name",
      align: "left",
      sortable: false,
    },
    {
      text: "Business",
      value: "request_business.name",
      align: "left",
      sortable: false,
    },
    {
      text: "Booking Type",
      value: "purpose",
      align: "left",
      sortable: false,
    },
    {
      text: "Number of Candidates",
      value: "candidate_number",
      align: "center",
      sortable: false,
      width: "10%",
    },
    {
      text: "Status",
      value: "status",
      align: "left",
      sortable: false,
      width: "15%",
    },
    {
      text: "Actions",
      value: "actions",
      align: "left",
      sortable: false,
      width: "10%",
      cellClass: "row-click-stop",
    },
  ]

  get candidateTableHeaders() {
    if (this.selectedBooking?.type === TYPES.BUSINESS_PAY) {
      return [
        {
          text: "Candidate",
          value: "candidate",
        },
        {
          text: "Share Code",
          value: "share_code",
        },
        {
          text: "Status",
          value: "status",
        },
      ]
    }

    return [
      {
        text: "Candidate",
        value: "candidate",
      },
      {
        text: "Status",
        value: "status",
      },
    ]
  }

  isMounted = false

  async beforeMount () {
    this.$store.dispatch('Business/all')
    .then(() => {
        this.isMounted = true
      })
  }

  // Methods
  handleFetch() {
    const options = {
      params: {
        search_name: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == "desc"
            ? "-" + this.options.orderBy
            : this.options.orderBy,
        statuses: this.options.statuses,
        type: this.options.type,
        payment_method: this.options.paymentMethod,
        candidate_name: this.options.candidateName,
        business_oid: this.options.businessOid,
        expand: ["request_business", "risk_profile", "booking_candidates"],
      },
    }
    if (this.$route.params.businessOid) {
      options.params["business_oid"] = this.$route.params.businessOid
    }
    return this.$store.dispatch("Booking/fetchList", options)
  }

  toRead(oid) {
    this.$router.push({
      name: "administrator-booking-read",
      params: {
        bookingOid: oid,
      },
    })
  }

  showCandidateList(booking) {
    this.showCandidateListDrawer = !this.showCandidateListDrawer
    this.selectedBooking = booking
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          "first_name",
          "last_name",
          "date_of_birth",
          "mobile",
          "email",
        ].includes(k) && item[k].toString().toLowerCase().includes(search)
      )
    })
  }

  handleClick(item) {
    this.toRead(item.object_id)
  }
}
